var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification-type" },
    _vm._l(_vm.options, function (alertType, count) {
      return _c("div", { key: `${alertType.id}-${count}` }, [
        _c(
          "div",
          {
            staticClass: "notification-type__option",
            on: {
              click: function ($event) {
                return _vm.selectType(alertType.id)
              },
            },
          },
          [
            _c(
              "v-icon",
              {
                staticClass: "notification-type__option-icon",
                attrs: {
                  size: "1.2em",
                  color: _vm.type === alertType.id ? "primary" : "gray",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.type === alertType.id
                        ? "fas fa-check-circle"
                        : "far fa-check-circle"
                    ) +
                    " "
                ),
              ]
            ),
            _c("div", [_vm._v(_vm._s(alertType.name))]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  "content-class": "normal-tooltip text-center",
                  bottom: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "div",
                            _vm._g(
                              { class: count === 0 ? "mb-1 ml-2" : "ml-2" },
                              on
                            ),
                            [
                              alertType.icon
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "notification-type__icon",
                                      attrs: { color: alertType.iconColor },
                                    },
                                    [_vm._v(_vm._s(alertType.icon) + " ")]
                                  )
                                : _c("v-badge", {
                                    staticClass: "ml-1",
                                    attrs: { content: "1" },
                                  }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [_c("span", [_vm._v(_vm._s(alertType.description))])]
            ),
          ],
          1
        ),
        _vm.type === "CONTINUOUS" && count === 0
          ? _c("div", { staticClass: "dynamic-threshold-settings" }, [
              _c(
                "div",
                { staticClass: "dynamic-threshold-title" },
                [
                  _vm._v(" Dynamic Threshold "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        "content-class": "normal-tooltip text-left",
                        bottom: "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "div",
                                  _vm._g(
                                    {
                                      class: count === 0 ? "mb-1 ml-2" : "ml-2",
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "notification-type__icon",
                                        attrs: {
                                          color: "#2196F3",
                                          size: "1.2em",
                                        },
                                      },
                                      [_vm._v(" fas fa-info-circle ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("div", [
                        _vm._v(
                          " Edit the Alert's notification type Dynamic Threshold settings. "
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          " This specifies at which rate and value change conditions will trigger the alert "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pl-2 dynamic-threshold-inputs-cont" },
                [
                  _c(
                    "input-wrapper-2",
                    {
                      staticClass: "mb-8",
                      attrs: { label: "Enabled", "full-width": "" },
                    },
                    [
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: {
                          dense: "",
                          label:
                            _vm.dynamicThreshold.enable === true ? "Yes" : "No",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.dynamicThreshold.enable,
                          callback: function ($$v) {
                            _vm.$set(_vm.dynamicThreshold, "enable", $$v)
                          },
                          expression: "dynamicThreshold.enable",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    staticClass: "my-2",
                    attrs: {
                      dense: "",
                      outlined: "",
                      "persistent-placeholder": "",
                      label: "Argument Name (starting point)",
                    },
                    model: {
                      value: _vm.dynamicThreshold.argumentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.dynamicThreshold, "argumentName", $$v)
                      },
                      expression: "dynamicThreshold.argumentName",
                    },
                  }),
                  _c("v-text-field", {
                    staticClass: "my-2",
                    attrs: { dense: "", outlined: "", label: "Next Level" },
                    model: {
                      value: _vm.dynamicThreshold.nextLevel,
                      callback: function ($$v) {
                        _vm.$set(_vm.dynamicThreshold, "nextLevel", _vm._n($$v))
                      },
                      expression: "dynamicThreshold.nextLevel",
                    },
                  }),
                  _c("v-select", {
                    ref: "changeLevelTypeInputRef",
                    refInFor: true,
                    staticStyle: { "max-width": "300px" },
                    attrs: {
                      dense: "",
                      outlined: "",
                      label: "Level Type",
                      items: _vm.changeLevelTypeOptions,
                      rules: [_vm.specificationRules.required],
                    },
                    model: {
                      value: _vm.dynamicThreshold.changeLevelType,
                      callback: function ($$v) {
                        _vm.$set(_vm.dynamicThreshold, "changeLevelType", $$v)
                      },
                      expression: "dynamicThreshold.changeLevelType",
                    },
                  }),
                  _c(
                    "input-wrapper-2",
                    {
                      attrs: {
                        label: "Change Direction Alert",
                        dense: "",
                        "full-width": "",
                      },
                    },
                    [
                      _c("v-switch", {
                        staticClass: "mt-0",
                        attrs: {
                          dense: "",
                          label:
                            _vm.dynamicThreshold.changeDirectionAlert === true
                              ? "Yes"
                              : "No",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.dynamicThreshold.changeDirectionAlert,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dynamicThreshold,
                              "changeDirectionAlert",
                              $$v
                            )
                          },
                          expression: "dynamicThreshold.changeDirectionAlert",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }